module.exports = __webpack_public_path__ + "img/file-error.9cd7a96b.svg";